export default "__VITE_ASSET__e0a2314f__"